import { useStore as useShapeStore } from '@/stores/v2/shape';
import { useStore as useProductStore } from '@/stores/v2/product';
import { ProductPrintPositionAddModel } from '@/typings';
import { ProductPrintVariant } from '@midocean/webapps-shared-domain';
import { PdpChoicesSetterType } from '@/setters/typings';

export function mapProductPrintPositions(): ProductPrintPositionAddModel[] {
  const shapeStore = useShapeStore();
  const productStore = useProductStore();

  const printPositionsData =
    shapeStore.personalization.proofs[0].productPrintPositions;

  return printPositionsData.map((pos) => {
    const position = productStore.data.productPrintPositions.find(
      (p) => p.name === pos.sapCode
    );
    const techniqueId = position?.printTechniques.find(
      (t) => t.printTechnique.code === pos.productPrintTechnique.sapCode
    )?.id;
    const technique = position?.printTechniques.find(
      (t) => t.printTechnique.code === pos.productPrintTechnique.sapCode
    );
    return {
      maxHeightMm: position?.maxHeightMm,
      maxWidthMm: position?.maxWidthMm,
      positionId: position?.id,
      positionName: pos.name,
      printPositionSAPCode: position?.name,
      technique: {
        id: techniqueId,
        printTechniqueSAPCode: pos.productPrintTechnique.sapCode,
        techniqueName: pos.productPrintTechnique.name,
        groupCode: technique?.printTechnique?.group?.code,
      },
    } as ProductPrintPositionAddModel;
  });
}

export function mapSelectedVariant(
  selectedVariantColor: string
): ProductPrintVariant | undefined {
  const productStore = useProductStore();

  if (productStore.data.variants) {
    const variant = productStore.data.variants.find(
      (varImg) => varImg.colour == selectedVariantColor
    );

    return variant || undefined;
  }
}

export function mapPositionsFromPdp(
  pdpChoices: PdpChoicesSetterType
): ProductPrintPositionAddModel[] {
  const productStore = useProductStore();

  const printPositionsFromPdp = [] as ProductPrintPositionAddModel[];

  if (
    pdpChoices.productPrintPositions &&
    pdpChoices.productPrintPositions.length > 0
  )
    pdpChoices.productPrintPositions.map((position) => {
      const positionToAdd = {} as ProductPrintPositionAddModel;

      if (productStore.data.productPrintPositions) {
        const filteredPosition = productStore.data.productPrintPositions.find(
          (pos) => {
            return position.printPositionSAPCode === pos.name;
          }
        );

        if (filteredPosition) {
          const filteredTechnique = filteredPosition.printTechniques.find(
            (tech) => {
              return (
                tech.printTechnique.code === position.printTechniqueSAPCode
              );
            }
          );

          positionToAdd.positionId = filteredPosition.id;
          positionToAdd.positionName = filteredPosition.name;
          positionToAdd.printPositionSAPCode = filteredPosition.name;
          positionToAdd.maxHeightMm = filteredPosition.maxHeightMm;
          positionToAdd.maxWidthMm = filteredPosition.maxWidthMm;
          if (filteredTechnique) {
            positionToAdd.technique = {
              id: filteredTechnique.id,
              printTechniqueSAPCode: filteredTechnique.printTechnique.code,
              techniqueName: filteredTechnique.printTechnique.name,
              groupCode: filteredTechnique.printTechnique.group.code,
            };
          }
        }

        printPositionsFromPdp.push(positionToAdd);
      }
    });

  return printPositionsFromPdp;
}
